import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Clock, Sparkles } from "lucide-react";
import { ClownNose } from "./ClownNose";

// Card destacada con portada (FOMO): imagen B/N + overlay + badge "Nuevo"
export const ArticuloDestacado = ({ a, dark = false }) => (
  <Link to={`/blog/${a.slug}`} data-testid={`articulo-destacado-${a.slug}`} className="group relative block h-full rounded-[2.5rem] overflow-hidden shadow-2xl min-h-[420px] lg:min-h-[520px]">
    <img loading="lazy" decoding="async" src={a.portada} alt={a.titulo} className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition duration-[1200ms]" />
    <div className="absolute inset-0 bg-gradient-to-t from-cometa-tinta via-cometa-tinta/40 to-transparent" />
    <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="absolute inset-0 p-8 lg:p-12 flex flex-col justify-end text-cometa-crema">
      <div className="flex items-center gap-3 mb-5">
        {a.nuevo && <span className="inline-flex items-center gap-1.5 bg-cometa-carmesi text-white text-xs font-bold tracking-[0.2em] px-3 py-1.5 rounded-full animate-pulse"><Sparkles size={12} /> NUEVO</span>}
        <span className="text-xs tracking-[0.25em] font-bold uppercase text-cometa-dorado">{a.categoria}</span>
        <ClownNose size={16} />
      </div>
      <h3 className="text-4xl lg:text-6xl leading-[0.98] mb-4 max-w-2xl">{a.titulo}</h3>
      <p className="text-lg lg:text-xl text-cometa-crema/85 max-w-xl mb-6">{a.resumen}</p>
      <div className="flex items-center gap-4">
        <span className="btn-gold px-7 py-3.5">Leer ahora <ArrowRight size={18} className="group-hover:translate-x-1 transition" /></span>
        <span className="inline-flex items-center gap-1.5 text-sm opacity-80"><Clock size={14} /> {a.lectura}</span>
      </div>
    </motion.div>
  </Link>
);
